import { cn } from "@wags/ui/ui-utils";
import type { ComponentProps } from "react";
import { useOverlayViewportRect } from "@wags/tanstack-start/browser";

type MobileOverlayViewportFrameProps = Omit<ComponentProps<"div">, "style"> & {
    active: boolean;
};

export function MobileOverlayViewportFrame({
    active,
    className,
    ...props
}: MobileOverlayViewportFrameProps) {
    const visibleFrame = useOverlayViewportRect(active);

    return (
        <div
            {...props}
            className={cn("flex min-h-0 flex-col", className)}
            style={{
                height:
                    visibleFrame != null ? `${visibleFrame.height}px` : "100%",
                transform:
                    visibleFrame?.offsetTop != null
                        ? `translateY(${visibleFrame.offsetTop}px)`
                        : undefined,
            }}
        />
    );
}
